export default __webpack_public_path__ + "errorIcon.a7d7a36ce7cf9ef30babb895ee4ef4a2.svg";